module.exports = __webpack_public_path__ + "static/media/r47.9d799d4c.jpg";